module.exports = __webpack_public_path__ + "static/img/06.a43c1e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/06.jpg
// module id = pw1o
// module chunks = 1